import React, { useRef } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut, getElementAtEvent } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import DoughnutLabel from 'chartjs-plugin-doughnutlabel-v3';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels, DoughnutLabel);

const LIMIT_LEGEND = 10;

export default function DoughnutChart(props) {
  const chartRef = useRef();

  let result = [];
  if (props.data.length > LIMIT_LEGEND) {
    result = props.data.sort((x, y) => y.value - x.value).slice(0, LIMIT_LEGEND);
    result = result.map(item => item.value);
  }

  const getTotal = function(myChart) {
    const sum = myChart.config.data.datasets[0].data.reduce((a, b) => a + b, 0)
    return `Total: ${sum}`
  }

  const options = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      elements: {
        center: {
          text: 'Desktop',
          color: '#36A2EB', //Default black
          fontStyle: 'Helvetica', //Default Arial
          sidePadding: 15 //Default 20 (as a percentage)
        }
      },
      datalabels: {
        display: 'auto',
        align: 'bottom',
        backgroundColor: '#ccc',
        borderRadius: 3,
        anchor: 'end',
        clip: 'true',
        font: {
          size: 10,
        },
        formatter: (val, ctx) => {
          if (result.length > 0) {
            if (result.includes(val)) {
              return ctx.chart.data.labels[ctx.dataIndex] + ' (' + val + ')';
            } else {
              return null
            }
          }
          else if (result.length === 0) {
            return ctx.chart.data.labels[ctx.dataIndex] + ' (' + val + ')';
          }
        },
        doughnutlabel: {
          labels: [{
            text: '550',
            font: {
              size: 20,
              weight: 'bold'
            }
          }, {
            text: 'total'
          }]
        }
      },
      doughnutLabel: {
				labels: [
					{
						text: '',
						font: {
							size: '35',
							family: 'Arial, Helvetica, sans-serif',
							style: 'italic',
							weight: 'bold'
						}
					},
					{
						text: getTotal,
						font: {
							size: '25'
						},
            color: 'white',
					},
					{
						text: '',
						font: {
							size: '20'
						},
					},
					{
						text: '',
						font: {
							size: '20'
						},
					},
				]
			}
    }
  }

  const data = {
    labels: props.data ? props.data.map(elem => elem.label) : [],
    datasets: [
      {
        label: '# of Votes',
        data: props.data ? props.data.map(elem => elem.value) : [],
        backgroundColor: [
          'rgba(255, 99, 132, 0.2)',
          'rgba(54, 162, 235, 0.2)',
          'rgba(255, 206, 86, 0.2)',
          'rgba(75, 192, 192, 0.2)',
          'rgba(153, 102, 255, 0.2)',
          'rgba(255, 159, 64, 0.2)',
        ],
        borderColor: [
          'rgba(255, 99, 132, 1)',
          'rgba(54, 162, 235, 1)',
          'rgba(255, 206, 86, 1)',
          'rgba(75, 192, 192, 1)',
          'rgba(153, 102, 255, 1)',
          'rgba(255, 159, 64, 1)',
        ],
        borderWidth: 1,
      },
    ],
  };

  const handleZoomOnClick = (event) => {
    const tmp = getElementAtEvent(chartRef.current, event);
    const index = tmp[0].index;
    const value = data.datasets[0].data[index];
    const label = data.labels[index];
    const elemFromDataset = props.data.find(elem => elem.label === label && elem.value === value);
    props.zoom({ data: elemFromDataset });
  }

  return (
    <Doughnut
      ref={chartRef}
      data={data}
      options={options}
      onClick={handleZoomOnClick}
    />
  );
}
